import React, { useState, useEffect } from "react";
import { useFormState } from "react-use-form-state";
import validate from "../../helpers/validate";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import Space from "../../components/Space";
import Button from "../../components/Button";
import Frame from "../../components/Frame";
import FrameFooter from "../../components/FrameFooter";
import InputRow from "../../components/InputRow";
import Label from "../../components/Label";
import TextInput from "../../components/TextInput";
import styles from "./CustomerInfoForm.module.scss";
export default function CustomerInfoForm({
  state,
  saving,
  onSave,
  isNew,
  simple = false,
  updatedCustomerForm,
  reset = false,
  setEmptying = null,
  disabled = false,
  showSave = true,
}) {
  const [formState, { text, email }] = useFormState({
    ...state,
  });
  const [initialValues, setInitialValues] = useState(state);
  const valid = validate(formState, {
    required: ["name", "email", "country", "address", "city", "zip", "state"],
  });
  const [address, setAddress] = useState(getAddress());

  useEffect(() => {
    if (reset) {
      setAddress("");
      setEmptying && setEmptying(false);
    }
  }, [state]);

  function enableSave() {
    return (
      address !== getAddress(initialValues) ||
      formState?.values.name != initialValues?.name ||
      formState?.values.email != initialValues?.email ||
      formState?.values.email_notifications_interval !=
        initialValues?.email_notifications_interval
    );
  }

  function MapResults(result) {
    setAddress(result.formatted_address);
    const addressComponents = result.address_components;

    const getComponent = (type) => {
      const component = addressComponents.find((comp) =>
        comp.types.includes(type)
      );
      return component ? component.long_name : "";
    };

    formState.setField(
      "address",
      `${getComponent("street_number")} ${getComponent("route")}`
    );
    formState.setField("city", getComponent("locality"));
    formState.setField("state", getComponent("administrative_area_level_1"));
    formState.setField("country", getComponent("country"));
    formState.setField("zip", getComponent("postal_code") || "no-zip-code");

    updatedCustomerForm && updatedCustomerForm(formState.values);
    setAddress(getAddress(formState.values));
  }

  function getAddress(values = formState.values) {
    var address = "";

    if (values.address !== undefined && values.address !== "") {
      address += values.address + ", ";
    }
    if (values.city !== undefined && values.city !== "") {
      address += values.city + ", ";
    }
    if (values.zip !== undefined && values.zip !== "") {
      address += values.zip + ", ";
    }
    if (values.state !== undefined && values.state !== "") {
      address += values.state + ", ";
    }
    if (values.country !== undefined && values.country !== "") {
      address += values.country;
    }
    return address;
  }

  function handleChange(address) {
    setAddress(address);
  }

  function handleSelect(address) {
    geocodeByAddress(address).then((results) => MapResults(results[0]));
  }

  function _save(e) {
    e.preventDefault();
    onSave(formState.values);
  }
  return (
    <>
      <Frame noframe={simple}>
        <form onSubmit={_save}>
          {!simple && (
            <InputRow>
              <Label text="Name">
                <TextInput
                  {...text("name")}
                  error={formState.touched.name && formState.errors.name}
                  required
                />
              </Label>

              <Label text="Email">
                <TextInput
                  {...email("email")}
                  error={formState.touched.email && formState.errors.email}
                  required
                />
              </Label>
            </InputRow>
          )}
          <InputRow>
            <Space size="s">
              <div>
                <span
                  style={{
                    display: "block",
                    color: simple ? "#777777" : "black",
                    paddingBottom: 7,
                  }}
                >
                  {simple ? "Billing address" : "Address"}
                </span>
              </div>

              <PlacesAutocomplete
                value={address}
                onChange={handleChange}
                onSelect={handleSelect}
                className={{ pointerEvents: "none", opacity: 0.5 }}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading,
                }) => (
                  <div>
                    <input
                      {...getInputProps({
                        //placeholder: 'Enter address',
                        className: styles.autocomplete,
                      })}
                    />
                    <div className={styles.autocompleteDiv}>
                      {loading && <div>Loading...</div>}
                      {suggestions.map((suggestion) => {
                        const className = suggestion.active
                          ? styles.autocompleteSuggestionActive
                          : styles.autocompleteSuggestion;

                        const style = suggestion.active
                          ? { backgroundColor: "#eeeeee", cursor: "pointer" }
                          : { backgroundColor: "#ffffff", cursor: "pointer" };

                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style,
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>
            </Space>
            {!simple && (
              <Label text="Customer ID">
                <TextInput {...text("id")} disabled />
              </Label>
            )}
          </InputRow>
          {/*
            The "Impact summary notification interval" select is hidden: nobody
            used it. email_notifications_interval still rides along in
            formState.values from the customer it was loaded with, so saving
            keeps each customer's interval as it was. Leaving it out would
            reset it to 0, and the API flushes queued summaries on a change to 0.
          */}

          {showSave && (
            <FrameFooter>
              <Button
                type="submit"
                theme="primary"
                isLoading={saving}
                disabled={!valid || !enableSave() || saving}
              >
                {isNew ? "Create" : "Save"}
              </Button>
            </FrameFooter>
          )}
        </form>
      </Frame>
    </>
  );
}
